import React from 'react';

import Modal from 'components/common/Modal';
import ModalTourRequest from 'components/Popup/ModalTourRequest';

const TourService: React.FC = () => {
  const { openModal, closeModal, ModalPortal } = Modal();

  const clickRequest = () => {
    openModal();
  };

  return (
    <div className="sub-wrap">
      <h2>투어·입주문의</h2>
      <p>
        하단의 ‘투어신청·입주 문의하기’ 버튼을 눌러 문의를 남겨주세요.
        <br />
        작성해주신 내용을 확인하여 로컬스티치 매니저가 연락드리겠습니다.
        <br />
        <br />
        우측 하단 오렌지 [문의] 버튼으로 채팅 문의주시면
        <br />
        더욱 빠른 답변을 받아보실 수 있습니다.
      </p>
      <div className="tour">
        <h3>문의안내</h3>
        <ul>
          <li>
            대표채널 상담 및 투어는 평일 오전 10시부터 오후 6시까지 운영됩니다.
          </li>
          <li style={{ marginBottom: '20px' }}>(점심시간 12:00 ~ 13:00)</li>

          <li>
            [메뉴]-[BRANCH] 페이지에서 로컬스티치 지점 정보를 확인하실 수
            있습니다.
          </li>
          <li>
            보다 정확한 안내를 위해 로컬스티치 지점을 먼저 살펴보시는 것을
            추천드려요.
          </li>
        </ul>
        <div className="in-btn">
          <a onClick={clickRequest} style={{ cursor: 'pointer' }}>
            투어신청.입주 문의하기
          </a>
        </div>
        <ModalPortal>
          <ModalTourRequest closeModal={closeModal} />
        </ModalPortal>
      </div>
    </div>
  );
};

export default TourService;
